<template>
  <div class="participationConditions">
    <el-form-item label="下单时间:" required>
      <div class="my_select_time mlr8">
        <el-date-picker
          prefix-icon="no_icon"
          v-model="currentObj.orderStartTime"
          type="datetime"
          placeholder="开始日期"
          size="small"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 185px; font-size: 12px"
          class="time1"
          :default-time="
            this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)
          "
          :clearable="false"
          :disabled="disabled"
          :picker-options="startOrderPicker"
        >
        </el-date-picker>
        <div class="time_to_text">至</div>
        <el-date-picker
          prefix-icon="no_icon"
          v-model="currentObj.orderEndTime"
          type="datetime"
          placeholder="结束日期"
          size="small"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 200px; font-size: 12px"
          class="time2"
          :default-time="
            this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)
          "
          :clearable="false"
          :picker-options="endOrderPicker"
          :disabled="disabled"
        >
        </el-date-picker>
        <i
          class="el-icon-circle-close date_icon1"
          v-if="!disabled"
          @click="clearOrderTime"
        ></i>
        <img
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
          alt=""
          class="date_icon2"
        />
      </div>
      <span class="ml8">期间内下单</span>&nbsp;
    </el-form-item>
    <el-form-item label="金额统计类型:" required>
      <el-radio-group
        v-model="currentObj.orderPaymentType"
        :disabled="disabled"
      >
        <el-radio :label="0" v-if="venderType!=1">实付金额</el-radio>
        <el-radio :label="1">订单金额 </el-radio>
      </el-radio-group>
      <div style="color: red">
        注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
      </div>
    </el-form-item>
    <el-form-item label="商品要求:" required>
      <el-radio-group v-model="currentObj.filterType" :disabled="disabled">
        <el-radio :label="0">全部商品</el-radio>
        <el-radio :label="1">指定商品</el-radio>
        <el-radio :label="2">排除商品</el-radio>
      </el-radio-group>
      <jd-button
        class="ml8"
        :disabled="loading"
        v-if="currentObj.filterType != 0"
        @click="selectGoods"
        >已选择{{ currentObj.skuIdList.length }}个</jd-button
      >
      <div class="mt16" v-if="currentObj.orderPaymentType==1&&currentObj.filterType == 1">
        <el-select
          v-model="currentObj.filterSkuType"
          :disabled="disabled"
          placeholder="请选择"
          style="width: 320px"
        >
          <el-option label="只要订单包含指定商品就整单计算" :value="0" />
          <el-option label="仅统计订单内指定商品的金额和件数" :value="1" />
        </el-select>
      </div>
    </el-form-item>
    <el-form-item label="商品件数:" label-position="left">
      <el-input
        v-model="currentObj.itemLimitCount"
        placeholder="请输入"
        class="inputW100"
        @input="currentObj.itemLimitCount = getNumberData(1, $event, 0, 1)"
        :disabled="disabled"
      ></el-input>
      <span class="ml8">件及以上</span>
    </el-form-item>
    <el-form-item label="订单金额:" label-position="left" required>
      <el-input
        v-model="currentObj.orderPaymentLimit"
        placeholder="请输入"
        class="inputW100"
        @input="currentObj.orderPaymentLimit = handleInput($event)"
        @blur="currentObj.orderPaymentLimit = formatOrderAmount($event)"
        :disabled="disabled"
      ></el-input>
      <span class="ml8">元及以上</span>
    </el-form-item>
    <el-form-item required label="订单状态:" label-position="left">
      <el-radio-group v-model="currentObj.orderType" :disabled="disabled">
        <el-radio :label="0">已付款</el-radio>
        <el-radio :label="1">已完成</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item required label="统计规则:" label-position="left">
      <el-radio-group v-model="currentObj.orderCountType" :disabled="disabled">
        <el-radio :label="0">按单笔订单统计</el-radio>
        <el-radio :label="1">按累计订单统计</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="下单跳转链接：">
      <div>
        <el-radio-group v-model="currentObj.goShopSetting" :disabled="disabled">
          <el-radio :label="0">进入店铺首页</el-radio>
          <el-radio :label="1">跳转指定小程序</el-radio>
          <el-radio :label="2">进入指定链接</el-radio>
        </el-radio-group>
      </div>
      <div class="mt16">
        <el-form-item
          v-if="currentObj.goShopSetting == 1"
          label="小程序appId："
          required
        >
          <el-input
            v-model="currentObj.goShopAppId"
            :disabled="disabled"
            placeholder="请输入小程序appId"
            style="width: 320px"
          />
        </el-form-item>
        <el-form-item
          v-if="currentObj.goShopSetting != 0"
          :label="
            currentObj.goShopSetting == 1 ? '页面路径path:' : '指定链接：'
          "
          :required="currentObj.goShopSetting == 2"
        >
          <div>
            <el-input
              v-model="currentObj.goShopUrl"
              :disabled="disabled"
              placeholder="请输入"
              style="width: 320px"
            />
          </div>
          <div style="color: red; font-size: 12px">
            {{
              currentObj.goShopSetting == 1
                ? "注意：path若不写，则默认进入小程序主页"
                : "注意：仅可填写京东域内的H5页面地址，不可设置外链。参考链接：https://m.jd.com/。"
            }}
          </div>
        </el-form-item>
      </div>
    </el-form-item>
    <!-- 指定/排除商品 -->
    <selectGoodsMonitor
      ref="selectGoFilter"
      v-if="isShowGoods"
      :isShow="isShowGoods"
      @close="confirmSelectGoods"
      :selectGoods="goodsList"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :disabled="disabled"
    >
    </selectGoodsMonitor>
  </div>
</template>
<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
export default {
  name: "participationConditions",
  components: {
    selectGoodsMonitor,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        orderStartTime: "",
        orderEndTime: "",
        orderPaymentType: 0,
        filterType: 0,
        skuIdList: [],
        itemLimitCount: "",
        orderPaymentLimit: "",
        orderType: 0,
        orderCountType: 0,
        filterSkuType: 0,
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      isShowGoods: false,
      startOrderPicker: {
        disabledDate: (time) => {
          if (this.currentObj.orderEndTime) {
            return (
              time.getTime() >
                new Date(this.currentObj.orderEndTime).valueOf() ||
              time.getTime() > new Date(this.currentObj.endTime).valueOf()
            );
          }
        },
      },
      endOrderPicker: {
        disabledDate: (time) => {
          if (this.currentObj.orderStartTime) {
            return (
              time.getTime() <
                new Date(this.currentObj.orderStartTime).valueOf() - 8.64e7 ||
              time.getTime() > new Date(this.currentObj.endTime).valueOf()
            );
          }
        },
      },
      goodsList: [],
    };
  },
  computed: {
    currentObj: {
      get() {
        console.log(this.value, "value");
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  watch: {
    venderType: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.currentObj.orderPaymentType = 1;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.currentObj.skuIdList.length > 0) {
      this.getGoodsList();
    }
  },
  methods: {
    clearOrderTime() {
      this.currentObj.orderStartTime = "";
      this.currentObj.orderEndTime = "";
    },
    handleInput(val) {
      let value = val;
      if (!value) return;
      // 移除所有非数字和非小数点字符
      value = value.replace(/[^\d.]/g, "");
      // 处理多个小数点，只保留第一个
      value = value.replace(/\.(?=.*\.)/g, "");
      // 限制小数点后两位
      value = value.replace(/^(\d+)\.(\d{0,2}).*/, "$1.$2");
      // 处理前导零：多个零只保留一个，零后跟小数点则保留
      value = value.replace(/^0+(?=0\.|\d)/, "");
      return value;
    },
    async getGoodsList() {
      try {
        this.loading = true;
        const res = await getTaobaoItemListSku({
          current: 1,
          size: this.currentObj.skuIdList.length,
          skuIds: this.currentObj.skuIdList,
        });
        this.loading = false;
        if (res.code == 1) {
          this.goodsList = res.data.records;
        }
      } catch (error) {
        this.loading = false;
      }
    },
    selectGoods() {
      this.isShowGoods = true;
    },
    confirmSelectGoods(data) {
      if (data) {
        this.currentObj.skuIdList = [];
        const goodsList = [];
        data.forEach((value, index) => {
          let obj = {
            skuId: data[index].skuId,
            logo: data[index].logo,
            price: data[index].jdPrice || data[index].price,
            title: data[index].skuName || data[index].title,
          };
          goodsList.push(obj);
          this.goodsList = goodsList;
          this.currentObj.skuIdList.push(obj.skuId);
        });
      }
      this.isShowGoods = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.participationConditions {
  width: fit-content;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 10px;
  .inputW100 {
    width: 100px;
  }
}
</style>
